// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__Dh0Tm","statusBadge":"styles_statusBadge__kVTqQ","organizationData":"styles_organizationData__atbOs","organizationInfo":"styles_organizationInfo__f5O1v"};